export const updateInfiniteDataItem = (oldData, matchFunc, updateFunc) => {
    const newPages = oldData === null || oldData === void 0 ? void 0 : oldData.pages.map(page => page.map(x => (matchFunc(x) ? updateFunc(x) : x)));
    return Object.assign(Object.assign({}, oldData), { pages: newPages });
};
export const removeInfiniteDataItem = (oldData, matchFunc) => {
    const newPages = oldData === null || oldData === void 0 ? void 0 : oldData.pages.map(page => page.filter(x => matchFunc(x) === false));
    return Object.assign(Object.assign({}, oldData), { pages: newPages });
};
export const updateInfiniteDataItemById = (oldData, updatedItem, updateFunc = (a, b) => (Object.assign(Object.assign({}, a), b))) => updateInfiniteDataItem(oldData, x => x.id === updatedItem.id, a => updateFunc(a, updatedItem));
export const findById = (data, id) => data === null || data === void 0 ? void 0 : data.pages.flat(1).find(x => x.id === id);
export const findTaskById = (data, id) => {
    for (let p = 0; p < data.pages.length; p += 1) {
        const page = data.pages[p];
        for (let m = 0; m < page.length; m += 1) {
            const mainTask = page[m];
            if (mainTask.id === id)
                return {
                    task: mainTask,
                    mainTask,
                    mainTaskIndex: m,
                    pageIndex: p,
                };
            // Try searching in children
            if (mainTask.children) {
                for (let s = 0; s < mainTask.children.length; s += 1) {
                    const subTask = mainTask.children[s];
                    if (subTask.id === id)
                        return {
                            task: subTask,
                            mainTask,
                            mainTaskIndex: m,
                            subTask,
                            subTaskIndex: s,
                            pageIndex: p,
                        };
                }
            }
        }
    }
    return null;
};
export const updateTask = (data, id, updateFunc) => {
    const findResult = findTaskById(data, id);
    if (!findResult)
        return data;
    const pages = [...data.pages];
    const page = [...pages[findResult.pageIndex]];
    pages[findResult.pageIndex] = page;
    let mainTask;
    if (findResult.subTask) {
        mainTask = Object.assign({}, page[findResult.mainTaskIndex]);
        mainTask.children = [...mainTask.children];
        mainTask.children[findResult.subTaskIndex] = updateFunc(Object.assign({}, mainTask.children[findResult.subTaskIndex]));
    }
    else {
        mainTask = updateFunc(Object.assign({}, page[findResult.mainTaskIndex]));
    }
    page[findResult.mainTaskIndex] = mainTask;
    return Object.assign(Object.assign({}, data), { pages });
};
export const insertNewMainTask = (data, task) => {
    let pages = [...data.pages];
    if (pages.length === 0)
        pages = [];
    pages[0] = [Object.assign({}, task), ...pages[0]];
    return Object.assign(Object.assign({}, data), { pages });
};
